import React from "react";
import styled from "@emotion/styled";
import { FormattedMessage } from "react-intl";
import enUSMsg from "@/utils/languages/en-us.json";

const Text = styled.span(({ theme, fontSize, color, ellipsis, underline }) => ({
  fontFamily: theme.fontFamily.primaryFont,
  fontWeight: theme.fontWeight.bold,
  fontSize: fontSize ? fontSize : "2rem",
  color: color ? color : theme.color.base_black,

  overflow: ellipsis ? "hidden" : "",
  whiteSpace: ellipsis ? "nowrap" : "",
  textOverflow: ellipsis ? "ellipsis" : "",
  textDecoration: underline ? "underline" : underline,
}));

const BoldText = ({
  id,
  children,
  fontSize,
  color,
  ellipsis,
  underline,
  className,
}) => {
  return (
    <Text
      fontSize={fontSize}
      color={color}
      ellipsis={ellipsis}
      underline={underline}
      className={className}
    >
      {id && <FormattedMessage id={id} defaultMessage={enUSMsg[id]} />}

      {children}
    </Text>
  );
};

export default BoldText;
